module.exports = __webpack_public_path__ + "img/clock-dist.49fbb775.svg";